import { render, staticRenderFns } from "./WithdrawVoucherRoyal.vue?vue&type=template&id=3398c511&"
import script from "./WithdrawVoucherRoyal.vue?vue&type=script&lang=js&"
export * from "./WithdrawVoucherRoyal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawVoucherRoyal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports